module.exports = __webpack_public_path__ + "img/search.27bcf7d9.svg";